import { Injectable } from '@angular/core';
import { ErrorDetail, DataMinerUiError } from './error-detail.model';

@Injectable()
export class ErrorManagerService {
    /**
    * The last error detail handled by this service. Useful for components that are displaying error info to the user.
    */
    public lastErrorDetail: ErrorDetail;

    /**
    * The Data Miner UI error handled by this service. Useful for components that are displaying error info to the user.
    */
    public dataMinerUiError: DataMinerUiError;

    public errorFeedsListKey;

    public errorExploreDataSetKey;

    public errorCurrentParrentKey;

    public dataMinerUiErrors;

    public dataMinerUiErrorsObservable;

    /**
     * Handles Not Found results (404s) to display according to application standards. In most cases, this will result in navigation to an error page.
     * This service does not log the error or response, so the caller must do so.
     * @param location
     * @param message
     * @param activityId
     * @param timestamp
     */
    public handleNotFound(location: string, message: string, activityId?: string, timestamp?: string) { }

    /**
     * Handles errors to display according to application standards. In most cases, this will result in navigation to an error page.
     * This service does not log the error.
     * @param error The error that should be handled.
     * @param title A title that should be displayed.
     * @param location Where the error occured
     * @param message More information please.
     * @param activityId Activity Id
     * @param timestamp Timestamp
     * @returns true if the error was completely handled by this method and the caller should stop processing.
     */
    public handleError(error: Error, title: string, location: string, activityId?: string, timestamp?: string, detailMessage?: string): boolean { return true; }

    /**
     * Removes an error from DataMinerUiErrors object.
     * @param errorParentKey The key for the parent where error object lives under.
     * @param errorKey The key for the error object.
     * @returns true.
    */
    public removeDataMinerUiError(errorParentKey: string, errorKey: string): boolean { return true; }

    /**
     * Adds an error to DataMinerUiErrors object.
     * This service does not log the error.
     * @param errorParentKey The key for the parent where error object goes under.
     * @param errorKey The key for the error object.
     * @param error The error object that has error information.
     * @param errorMessage The error message for the error object.
     * @returns true.
     */
    public saveDataMinerUiError(errorParentKey: string, errorKey: string, error: any, message: string): boolean { return true; }
}



// WEBPACK FOOTER //
// ./src/app/shared/error-handling/error-manager.service.ts